var render = function render(){var _vm=this,_c=_vm._self._c;return _c('country-flag',{attrs:{"country":_vm.language,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }